module.exports = __webpack_public_path__ + "img/gb97_1.prt.38c52485.jpg";